module.exports = __webpack_public_path__ + "static/reindeer-back-81093230197e2bed9202ae38b6e27d94.png";